import { IonSkeletonText } from "@ionic/react";
import React from "react";
import ProductShelfSkeleton from "../../../parhato2/src/entities/Product/ProductShelf/ProductShelfSkeleton";
import CategoriesSkeleton from "../../../parhato2/src/entities/Category/categories-skeleton";
import { useIsLg } from "../../../hooks/useIsLg";

const HomePageSkeleton = () => {
  const isLg = useIsLg();

  return (
    <div className="flex flex-col gap-4 mx-2.5 lg:col-span-2 lg:grid lg:grid-cols-2 lg:gap-3">
      <div className="flex flex-col gap-2 h-[21rem] lg:col-span-2 lg:h-auto">
        <div className="flex gap-5">
          <IonSkeletonText
            animated
            className="w-full max-h-[10rem] min-h-[10rem] rounded-lg lg:max-h-[15rem] lg:min-h-[15rem]"
          />
          <IonSkeletonText
            animated
            className="w-full max-h-[10rem] min-h-[10rem] rounded-lg lg:max-h-[15rem] lg:min-h-[15rem]"
          />
          <IonSkeletonText
            animated
            className="w-full max-h-[10rem] min-h-[10rem] rounded-lg lg:max-h-[15rem] lg:min-h-[15rem]"
          />
        </div>
        <IonSkeletonText
          animated
          className="w-full max-h-[10rem] min-h-[10rem] rounded-xl lg:max-h-[15rem] lg:min-h-[15rem]"
        />
      </div>

      <ProductShelfSkeleton key={1} classnameSkeleton="lg:col-span-1" />
      <ProductShelfSkeleton key={2} classnameSkeleton="lg:col-span-1" />
      <ProductShelfSkeleton key={3} classnameSkeleton="lg:col-span-1" />
      <ProductShelfSkeleton key={4} classnameSkeleton="lg:col-span-1" />

      {isLg && (
        <>
          <ProductShelfSkeleton key={5} classnameSkeleton="lg:col-span-1" />
          <ProductShelfSkeleton key={6} classnameSkeleton="lg:col-span-1" />
        </>
      )}

      <div className="lg:col-span-2">
        <CategoriesSkeleton key={7} />
      </div>
    </div>
  );
};

export default HomePageSkeleton;
